export const EVENTS = {
  ORGANISATION_USER_ADDED: 'organisation.user.added',
} as const;
